import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Kredit-/ Debit Karte',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Pay by bank',
    [PaymentMethod.SepaDebit]: 'EC-Karte / IBAN',
    [PaymentMethod.Cash]: 'Barzahlung',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Andere Zahlungsart',
  },
};
